<template>
  <div>
    <h2>My Permits & Records</h2>
    <div style="margin-top: 5px" class="e-card" v-if="isAdmin">
      <div class="e-card-content" style="display: flex; width: 50%">
        <ejs-autocomplete
          ref="userProfileRef"
          :dataSource="permitContacts"
          placeholder="Site Owner"
          :fields="{ value: 'ownerFullInfo' }"
          :minLength="3"
          sortOrder="Ascending"
          filterType="Contains"
          float-label-type="Always"
          :change="onUserSelection"
          cssClass="e-static-clear"
        />
      </div>
    </div>
    <my-records-grid :dataSource="openRecords" gridTitle="Open Permits & Records"
    :isAdmin="isAdmin"
    :onQueryCell="onOpenRecordsQuery" />
    <my-records-grid :dataSource="historicalRecords" gridTitle="Historical Permits & Records"
    :isAdmin="isAdmin"
    :onQueryCell="onHistoricalRecordsQuery" />
  </div>
</template>

<script>
import { AutoCompletePlugin } from "@syncfusion/ej2-vue-dropdowns";
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import { getMyRecords } from "../../search-requests/services/municipality-api";
import { FETCH_PERMIT_CONTACTS } from "../../settings/store";
import myRecordsGrid from "../components/my-records-grid.vue";

Vue.use(AutoCompletePlugin);

export default {
  components: { myRecordsGrid },
  name: "Records",
  data() {
    return {
      historicalRecords: [],
      openRecords: [],
      isAdmin: false,
    };
  },
  computed: {
    ...mapGetters({
      loggedUser: "loggedUser",
      selectedUser: "selectedUser",
      permitContacts: "permitContacts",
    }),
  },
  watch: {
    loggedUser(loggedUser) {
      this.checkUserRole(loggedUser.roles.map((x) => x.roleName));
    },
  },
  methods: {
    ...mapActions({
      getInvoiceOwners: FETCH_PERMIT_CONTACTS,
    }),
    async getMyRecords(email, ownerId, ownerContactId) {
      const townerId = ownerId || 0;
      const townerContactId = ownerContactId || 0;
      await getMyRecords(email, townerId, townerContactId).then((res) => {
        const { data } = res;
        this.openRecords = data.filter((x) => x.isClosedFlag===false);
        this.historicalRecords = data.filter((x) => x.isClosedFlag===true);
      });
    },
    onOpenRecordsQuery(args) {
      if (args.column.commands) {
        try {
        // note: this was moved out from my-records component, logic is not changed
        // both open and historical shared the same event handler, so moved out; to be able to
        // customize the bahavior independently.
          if (!args.data.documentId) {
            args.cell.querySelector('.viewpdfbtn').classList.add('hidebtn');
          }
          if (!(this.isAdmin
          && args.data.documentId?.includes('R') && new Date(args.data.expiryDate).getYear() >= new Date().getYear())) {
            args.cell.querySelector('.gotobtn').classList.add('hidebtn');
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    onHistoricalRecordsQuery(args) {
      if (args.column.commands) {
        try {
        // note: this was moved out from my-records component, logic is not changed
        // both open and historical shared the same event handler, so moved out; to be able to
        // customize the bahavior independently.
          if (!args.data.documentId) {
            args.cell.querySelector('.viewpdfbtn').classList.add('hidebtn');
          }
          if (!(this.isAdmin
          && args.data.documentId?.includes('R') && new Date(args.data.expiryDate).getYear() >= new Date().getYear())) {
            args.cell.querySelector('.gotobtn').classList.add('hidebtn');
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    async onUserSelection(e) {
      if (e.e) {
        if (e.value) {
          const { emailAddress } = e.itemData;
          const { ownerID } = e.itemData;
          const { ownerContactID } = e.itemData;

          /* STS-450 */
          // await this.$store.commit(SET_SELECTED_USER, { selectedUser: e.itemData });

          this.getMyRecords(emailAddress, ownerID, ownerContactID);
        } else {
          this.openRecords = null;
          this.historicalRecords = null;
        }
      }
    },
    checkUserRole(roles) {
      this.isAdmin = roles.includes("Admin") || roles.includes("SuperAdmin");
      if (!this.isAdmin) {
        this.getMyRecords(this.loggedUser.email, 0, 0);
      }
    },
  },
  created() {
    this.getInvoiceOwners();
    if (this.loggedUser) {
      this.checkUserRole(this.loggedUser.roles.map((x) => x.roleName));
    }
  },
};
</script>
